// extracted by mini-css-extract-plugin
module.exports = {"qa_wrapper":"__3gt_MM2w","title":"M_NXYzV0","qa_wrapper_body":"bRZ7qQbK","qa_wrapper_body_item":"ixKlquJ5","item_title":"tcONB_d6","item_num":"oGDgp_Ij","item_text":"ubS_AFlX"};